(function () {
  var roots = document.querySelectorAll('[data-klairs-skin-fortune]');
  if (!roots.length) return;
  document.body.classList.add('klairs-skin-fortune-page');
  suppressRewardOverlays();
  window.setTimeout(suppressRewardOverlays, 900);
  window.setTimeout(suppressRewardOverlays, 2400);
  if (window.MutationObserver) {
    new MutationObserver(suppressRewardOverlays).observe(document.body, { childList: true, subtree: true });
  }

  var fortunes = [
    'Your skin fortune says: choose the calm path and let the glow catch up.',
    'A blue little sign appears: your barrier wants comfort before ambition.',
    'Today’s pull is soft power. Hydrate first, decide the rest later.',
    'The lucky layer is the one your skin can repeat tomorrow.',
    'Your ticket says: fewer steps, better listening, softer skin.',
    'A quiet routine is not boring. It is how glow learns your name.',
    'Your skin is asking for water, patience, and one less experiment.',
    'The mirror is not a scoreboard. Start with comfort and keep the day yours.',
    'A small ritual becomes lucky when you actually enjoy repeating it.',
    'The blue signal is clear: cool it down, seal it in, move gently.',
    'Today’s glow is hiding behind one very simple habit.',
    'The best pull is not always rare. Sometimes it is the one you can keep.',
    'Your routine does not need drama to feel like a tiny ceremony.',
    'This is a good day to protect first and chase glow second.',
    'Your ticket opened on comfort. Let your skin exhale.',
    'A lucky face day starts with being less mean to your barrier.',
    'The skincare universe has spoken: gentle is not a downgrade.',
    'Tonight’s softness is already being negotiated by today’s sunscreen.',
    'Your skin sign says: press, do not rub. Wait, do not rush.',
    'A little blue calm is trying to become tomorrow’s main character.'
  ];

  var missions = [
    'Use one calming layer and skip one unnecessary active.',
    'Give each layer thirty seconds before the next step.',
    'Write down what your skin actually feels like today.',
    'Use lukewarm water instead of hot water tonight.',
    'Apply sunscreen before checking messages.',
    'Choose comfort over curiosity if skin feels stressed.',
    'Patch test instead of guessing.',
    'Seal hydration before your skin feels tight.',
    'Replace rubbing with gentle pressing.',
    'Keep your routine under five calm steps today.',
    'Make tonight a three-step routine: cleanse, hydrate, seal.',
    'Let one product absorb fully before judging the finish.'
  ];

  var scratchHints = [
    'The silver is starting to give.',
    'A little more. The pull is still hiding.',
    'The ticket is warming up.',
    'Almost there. Something blue is underneath.',
    'Last scratches. Hold the suspense.'
  ];
  var moods = ['CALM', 'DEW', 'BLUE', 'GLOW', 'RESET', 'SOFT', 'LUCK', 'COOL'];
  var careSigns = ['BARRIER', 'HYDRATION', 'AZULENE', 'VITAMIN C', 'PEPTIDE', 'COMFORT', 'SPF', 'RESET'];
  var rewards = [
    { label: 'SKIN NOTE', tier: 'common', pullTitle: 'A gentle sign', note: 'Common pull, but useful. Come back tomorrow for a fresh ticket.', weight: 55 },
    { label: 'ROUTINE MISSION', tier: 'soft-win', pullTitle: 'Soft win', note: 'You unlocked a small mission for today’s routine.', weight: 25 },
    { label: 'SAMPLE UNLOCK', tier: 'sample-unlock', pullTitle: 'Sample signal', note: 'A soft surprise appeared. Check eligible gifts before checkout.', weight: 12 },
    { label: 'LUCKY 5', tier: 'lucky-5', pullTitle: 'Lucky pull', note: 'A small skin treat is waiting for today’s routine.', weight: 6 },
    { label: 'LUCKY 10', tier: 'lucky-10', pullTitle: 'Rare pull', note: 'Rare pull. Today’s ticket brought a brighter little reward.', weight: 1.8 },
    { label: 'BLUE MOON', tier: 'blue-moon', pullTitle: 'Blue Moon pull', note: 'The rarest skin fortune found you today.', weight: 0.2 }
  ];

  function todayKey() {
    var now = new Date();
    return now.getFullYear() + '-' + String(now.getMonth() + 1).padStart(2, '0') + '-' + String(now.getDate()).padStart(2, '0');
  }

  function pick(list) {
    return list[Math.floor(Math.random() * list.length)];
  }

  function pickReward() {
    var total = rewards.reduce(function (sum, item) { return sum + item.weight; }, 0);
    var roll = Math.random() * total;
    for (var i = 0; i < rewards.length; i += 1) {
      roll -= rewards[i].weight;
      if (roll <= 0) return rewards[i];
    }
    return rewards[0];
  }

  function createResult() {
    var reward = pickReward();
    return {
      date: todayKey(),
      mood: pick(moods),
      care: pick(careSigns),
      reward: reward.label,
      tier: reward.tier,
      pullTitle: reward.pullTitle,
      rewardNote: reward.note,
      fortune: pick(fortunes),
      mission: pick(missions)
    };
  }

  function setText(root, result) {
    root.querySelector('[data-fortune-mood]').textContent = result.mood;
    root.querySelector('[data-fortune-care]').textContent = result.care;
    root.querySelector('[data-fortune-reward]').textContent = result.reward;
    root.querySelector('[data-fortune-message]').textContent = result.fortune;
    root.querySelector('[data-fortune-mission]').textContent = 'Mini mission: ' + result.mission;
    root.querySelector('[data-fortune-date]').textContent = result.date;
    root.querySelector('[data-fortune-rarity]').textContent = (result.tier || 'common').replace('-', ' ');
    root.querySelector('[data-fortune-pull-title]').textContent = result.pullTitle || 'Today’s skin signal';
    root.querySelector('[data-fortune-reward-note]').textContent = result.rewardNote || 'Your daily ticket has opened.';
    root.setAttribute('data-reward-tier', result.tier || 'common');
  }

  function storageKey(root) {
    var customer = root.getAttribute('data-customer-key') || 'guest';
    return 'klairsSkinFortune:' + customer + ':' + todayKey();
  }

  function suppressRewardOverlays() {
    [
      '#Avada-Joy_FloatingButton',
      '.Avada-Preview__ReferralCard',
      '.Avada-Joy_ButtonWidget',
      '.joy-points-calculator__block--embed'
    ].forEach(function (selector) {
      document.querySelectorAll(selector).forEach(function (node) {
        node.style.setProperty('display', 'none', 'important');
        node.style.setProperty('visibility', 'hidden', 'important');
        node.style.setProperty('pointer-events', 'none', 'important');
      });
    });
  }

  function setCountdown(root) {
    var countdown = root.querySelector('[data-fortune-countdown]');
    if (!countdown) return;
    var now = new Date();
    var end = new Date(now);
    end.setHours(23, 59, 59, 999);
    var diff = Math.max(0, end.getTime() - now.getTime());
    var hours = Math.floor(diff / 3600000);
    var minutes = Math.floor((diff % 3600000) / 60000);
    countdown.textContent = 'Today’s ticket resets in ' + hours + 'h ' + String(minutes).padStart(2, '0') + 'm.';
  }

  function setupScratch(root, canvas) {
    var ctx = canvas.getContext('2d', { willReadFrequently: true });
    var wrap = root.querySelector('[data-fortune-scratch-wrap]');
    var hint = root.querySelector('[data-fortune-hint]');
    var sealedStatus = root.querySelector('[data-fortune-sealed-status]');
    var drawing = false;
    var foilImage = null;
    var foilUrl = canvas.getAttribute('data-foil-url');

    if (foilUrl) {
      foilImage = new Image();
      foilImage.onload = function () {
        resize();
      };
      foilImage.src = foilUrl;
    }

    function resize() {
      var rect = wrap.getBoundingClientRect();
      var ratio = window.devicePixelRatio || 1;
      canvas.width = Math.max(1, Math.floor(rect.width * ratio));
      canvas.height = Math.max(1, Math.floor(rect.height * ratio));
      canvas.style.width = rect.width + 'px';
      canvas.style.height = rect.height + 'px';
      ctx.setTransform(ratio, 0, 0, ratio, 0, 0);
      drawCover(rect.width, rect.height);
    }

    function drawCover(width, height) {
      ctx.globalCompositeOperation = 'source-over';
      ctx.globalAlpha = 1;
      ctx.fillStyle = '#dfe8f2';
      ctx.fillRect(0, 0, width, height);
      if (foilImage && foilImage.complete) {
        ctx.globalAlpha = 0.92;
        ctx.fillStyle = ctx.createPattern(foilImage, 'repeat');
      } else {
        var gradient = ctx.createLinearGradient(0, 0, width, height);
        gradient.addColorStop(0, '#d7e1ec');
        gradient.addColorStop(0.45, '#f7fbff');
        gradient.addColorStop(1, '#b7c6d8');
        ctx.fillStyle = gradient;
      }
      ctx.fillRect(0, 0, width, height);
      ctx.globalAlpha = 1;
      ctx.fillStyle = 'rgba(246, 250, 255, 0.38)';
      ctx.fillRect(0, 0, width, height);
      ctx.fillStyle = 'rgba(255, 255, 255, 0.24)';
      for (var i = 0; i < 12; i += 1) {
        ctx.beginPath();
        ctx.arc((width / 12) * i + 18, 22 + (i % 3) * 18, 2.5, 0, Math.PI * 2);
        ctx.fill();
      }
      ctx.fillStyle = 'rgba(12, 36, 69, 0.78)';
      ctx.font = '900 13px sans-serif';
      ctx.textAlign = 'center';
      ctx.textBaseline = 'middle';
      ctx.fillText('SCRATCH TO REVEAL', width / 2, height / 2);
      ctx.font = '800 10px sans-serif';
      ctx.fillStyle = 'rgba(12, 36, 69, 0.54)';
      ctx.fillText('ONE PULL ONLY', width / 2, height / 2 + 24);
    }

    function position(event) {
      var point = event.touches ? event.touches[0] : event;
      var rect = canvas.getBoundingClientRect();
      return { x: point.clientX - rect.left, y: point.clientY - rect.top };
    }

    function scratch(event) {
      if (!drawing) return;
      event.preventDefault();
      var pos = position(event);
      ctx.globalCompositeOperation = 'destination-out';
      ctx.beginPath();
      ctx.arc(pos.x, pos.y, 24, 0, Math.PI * 2);
      ctx.fill();
      var percent = scratchedPercent(ctx, canvas);
      updateProgress(root, percent);
      updateTension(root, percent, hint, sealedStatus);
      if (percent > 68) reveal(root, canvas);
    }

    function start(event) {
      drawing = true;
      root.classList.add('is-scratching');
      scratch(event);
    }

    function stop() {
      drawing = false;
      root.classList.remove('is-scratching');
    }

    canvas.addEventListener('mousedown', start);
    canvas.addEventListener('mousemove', scratch);
    window.addEventListener('mouseup', stop);
    canvas.addEventListener('touchstart', start, { passive: false });
    canvas.addEventListener('touchmove', scratch, { passive: false });
    canvas.addEventListener('touchend', stop);
    window.addEventListener('resize', resize);
    resize();
  }

  function scratchedPercent(ctx, canvas) {
    var pixels = ctx.getImageData(0, 0, canvas.width, canvas.height).data;
    var clear = 0;
    for (var i = 3; i < pixels.length; i += 4) {
      if (pixels[i] < 20) clear += 1;
    }
    return clear / (pixels.length / 4) * 100;
  }

  function updateProgress(root, percent) {
    var progress = root.querySelector('[data-fortune-progress]');
    if (progress) progress.style.width = Math.min(100, Math.round(percent)) + '%';
  }

  function updateTension(root, percent, hint, sealedStatus) {
    var stage = Math.min(scratchHints.length - 1, Math.floor(percent / 14));
    if (hint) hint.textContent = scratchHints[stage];
    if (sealedStatus) {
      if (percent > 54) sealedStatus.textContent = 'Almost open';
      else if (percent > 28) sealedStatus.textContent = 'The pull is waking up';
      else if (percent > 8) sealedStatus.textContent = 'Keep scratching';
    }
    root.classList.toggle('is-near-reveal', percent > 46);
  }

  function reveal(root, canvas) {
    if (root.classList.contains('is-revealed') || root.classList.contains('is-locked')) return;
    root.classList.remove('is-scratching');
    root.classList.add('is-near-reveal');
    root.classList.add('is-revealed');
    var key = storageKey(root);
    var result = root.__fortuneResult;
    if (result) {
      try {
        localStorage.setItem(key, JSON.stringify(result));
      } catch (error) {}
    }
    if (canvas) {
      canvas.style.opacity = '0';
    }
    var button = root.querySelector('[data-fortune-button]');
    if (button) {
      button.textContent = 'Come back tomorrow';
      button.disabled = true;
    }
    updateProgress(root, 100);
    if (window.navigator && window.navigator.vibrate) {
      window.navigator.vibrate([18, 40, 28]);
    }
    burst(root);
  }

  function burst(root) {
    var wrap = root.querySelector('[data-fortune-scratch-wrap]');
    if (!wrap) return;
    var holder = document.createElement('div');
    holder.className = 'klairs-skin-fortune__burst';
    var count = 30;
    for (var i = 0; i < count; i += 1) {
      var particle = document.createElement('span');
      particle.className = 'klairs-skin-fortune__particle';
      var angle = Math.PI * 2 * (i / count);
      var distance = 92 + Math.random() * 140;
      particle.style.setProperty('--x', Math.cos(angle) * distance + 'px');
      particle.style.setProperty('--y', Math.sin(angle) * distance + 'px');
      particle.style.animationDelay = (Math.random() * 120) + 'ms';
      holder.appendChild(particle);
    }
    wrap.appendChild(holder);
    window.setTimeout(function () {
      holder.remove();
    }, 1400);
  }

  roots.forEach(function (root) {
    var requiresLogin = root.getAttribute('data-requires-login') === 'true';
    var loggedIn = root.getAttribute('data-logged-in') === 'true';
    var button = root.querySelector('[data-fortune-button]');
    var canvas = root.querySelector('[data-fortune-canvas]');
    var saved = null;
    setCountdown(root);

    if (requiresLogin && !loggedIn) {
      root.classList.add('requires-login');
      if (button) button.disabled = true;
      return;
    }

    try {
      saved = JSON.parse(localStorage.getItem(storageKey(root)));
    } catch (error) {
      saved = null;
    }

    root.__fortuneResult = saved && saved.date === todayKey() ? saved : createResult();
    setText(root, root.__fortuneResult);

    if (saved && saved.date === todayKey()) {
      root.classList.add('is-locked');
      root.setAttribute('data-reward-tier', saved.tier || 'common');
      if (button) {
        button.textContent = 'Come back tomorrow';
        button.disabled = true;
      }
      if (canvas) canvas.style.opacity = '0';
      return;
    }

    if (canvas) setupScratch(root, canvas);
    if (button) {
      button.addEventListener('click', function () {
        root.classList.add('is-near-reveal');
        window.setTimeout(function () {
          reveal(root, canvas);
        }, 260);
      });
    }
  });
})();
